import React, { useEffect } from "react";
import { X, LogIn, UserPlus, Building2, Lock } from "lucide-react";

export default function AuthRequiredModal({ onClose, onLogin, onRegister }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      <div
        className="relative z-10 w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Kapat */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 transition"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Üst alan */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-700 px-6 pt-8 pb-6 text-center">
          <div className="w-14 h-14 rounded-2xl bg-amber-400 flex items-center justify-center mx-auto mb-4 shadow-lg">
            <Building2 className="w-7 h-7 text-slate-900" />
          </div>
          <h2 className="text-lg font-bold text-white">Firma Eklemek İçin</h2>
          <p className="text-slate-300 text-sm mt-1">Üye olmanız veya giriş yapmanız gerekiyor.</p>
        </div>

        {/* İçerik */}
        <div className="p-5 space-y-3">
          <div className="flex items-center gap-2.5 text-xs text-slate-500 bg-slate-50 rounded-xl px-3 py-2.5 border border-slate-100">
            <Lock className="w-3.5 h-3.5 text-slate-400 shrink-0" />
            Kısaca üye olarak giriş yaparak, firmalarınızı kolayca ekleyebilirsiniz. Ücretsiz üyelik ile hemen başlayın!
          </div>

          <button
            onClick={onRegister}
            className="w-full flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold py-3 rounded-xl transition"
          >
            <UserPlus className="w-4 h-4" />
            Üye Ol — Ücretsiz
          </button>

          <button
            onClick={onLogin}
            className="w-full flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-700 text-white font-semibold py-3 rounded-xl transition"
          >
            <LogIn className="w-4 h-4" />
            Giriş Yap
          </button>

          <button
            onClick={onClose}
            className="w-full text-sm text-slate-400 hover:text-slate-600 py-1.5 transition"
          >
            Vazgeç
          </button>
        </div>
      </div>
    </div>
  );
}